
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/rEditor/rootComps/helpHome/styles.scss.css.virtualfile';
        module.exports = {"blocks":"_blocks_1kel4_7","list":"_list_1kel4_15"};